import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { type BadgeType } from '@bbkPricingPage/types/pricing-table-types';

type BadgeProps = {
  className?: string;
  variant?: keyof typeof BadgeType;
} & React.ComponentPropsWithoutRef<'div'>;

const Badge = ({
  variant = 'block',
  className,
  children,
  ...rest
}: BadgeProps) => {
  return (
    <div
      className={cs(
        'tw-whitespace-nowrap tw-bg-[var(--pricingtable-badge-color)] tw-px-4 tw-py-0.5 tw-text-center tw-text-[var(--pricing-page-button-text-color)]',
        [
          variant === 'block' && [
            'tw-min-w-min tw-rounded-pricingtable-border-radius',
          ],
          variant === 'full' && [
            'tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-t-[inherit]',
          ],
        ],
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Badge;
